import { z } from 'zod';
import { SkillSourceSchema } from '../tools/skills.ts';

export const SkillListItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  source: SkillSourceSchema,
  enabled: z.boolean(),
  version: z.number().int().positive(),
  always_on: z.boolean(),
  /** How many times the model has used a marketplace skill; null for a personal skill. */
  invocation_count: z.number().int().nonnegative().nullable(),
  updated_at: z.string(),
});
export type SkillListItem = z.infer<typeof SkillListItemSchema>;

export const SkillListResponseSchema = z.object({
  skills: z.array(SkillListItemSchema),
  /** Whether the user may save skills of their own. */
  personal_skills: z.boolean(),
  /** The vendor's product, whose marketplace this is. */
  product_name: z.string(),
});
export type SkillListResponse = z.infer<typeof SkillListResponseSchema>;

export const MarketplaceSkillSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  always_on: z.boolean(),
  added: z.boolean(),
  invocation_count: z.number().int().nonnegative(),
  updated_at: z.string(),
});
export type MarketplaceSkill = z.infer<typeof MarketplaceSkillSchema>;

export const MarketplaceResponseSchema = z.object({
  skills: z.array(MarketplaceSkillSchema),
  product_name: z.string(),
});
export type MarketplaceResponse = z.infer<typeof MarketplaceResponseSchema>;

export const SkillDetailSchema = SkillListItemSchema.extend({
  instructions: z.string(),
  files: z.array(z.string()),
});
export type SkillDetail = z.infer<typeof SkillDetailSchema>;

/** Adds or removes a marketplace skill, or switches one of the user's own on or off. */
export const SkillUpdateRequestSchema = z.strictObject({ enabled: z.boolean() });
export type SkillUpdateRequest = z.infer<typeof SkillUpdateRequestSchema>;
